import UserMenu from 'tennders-stracture/layouts/views/user-menu/UserMenu'

const GeneralLayoutUserMenu = () => <UserMenu />

GeneralLayoutUserMenu.displayName = 'GeneralLayoutUserMenu'
export default GeneralLayoutUserMenu
